export const SET_MOBILE_USER = "SET_MOBILE_USER";

export function setMobileRole(userStatusData) {
  return {
    type: SET_MOBILE_USER,
    data: { userStatusData },
  };
}
